import React from "react";
import "./SponsorsComponent.css";
import PageCover from "../HeaderComponents/PageCover";
import Image from "./ImageComponent/ImageComponent";
import { Fade } from "react-reveal";
import ComingSoon from "../ComingSoonComponent/ComingSoonComponent";
import { Helmet } from "react-helmet";

const sponsors = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>TEDxBITD - Our Sponsors</title>
        <meta
          name="description"
          content="TEDx events are known for highlighting innovative ideas & changes through the stage. Sponsoring TEDxBITD will help them grow through the offers provided alongside the opportunity to be a part of something unique."
        />
        <meta
          name="keywords"
          content="ted,tedx,bit,durg,speakers,bitd,event,campus,college,bhilai"
        />
      </Helmet>
      {/* <ComingSoon
        title="Be Our Proud Partners"
        image="sponsors.png"
        button="Partner with Us"
        link="sponsornominations"
      >
        <strong>TEDxBITD</strong> intends to bring a change to the audience with
        amazing speakers sharing their ideas and life stories. We're excited to
        be a TEDx event licensee and we're looking for groups or companies that
        believe in the power of youth events, sharing ideas, and supporting our
        event.
        <br />
        <br />
        <strong>TEDxBITD</strong> would be more than pleased to discuss the ways
        you could be a part of this incredibly new and unique experience. For
        additional information, reach us.
      </ComingSoon> */}
      <PageCover title="Sponsors 2023" />
      <center className="applyBtn">
        {/* <h3>Become our proud sponsors for the 2024 version</h3> */}
        {/* <div className="inputGroup">
          <a href="/sponsornominations">
            Apply&nbsp;&nbsp;<i className="fas fa-arrow-right"></i>
          </a>
        </div> */}
      </center>
      <div className="sponsorsCont">
        {/* <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Title</strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
              <Image
                  path="./assets/images/sponsors/idea-codify.png"
                  title="idea codify"
                />
              </Fade>
            </div>
          </Fade>
        </div> */}

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Chattisgarh </strong> Shashan
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="https://cgstate.gov.in/"
                  path="./assets/images/sponsors/cg.png"
                  title="Chhattisgarh Shashan"
                />
              </Fade>
              <a
                href="https://cgstate.gov.in/"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "Introducing our first sponsor, We are honored to have
                  Government of Chhattisgarh as one of our sponsors..."
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Banking </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="https://www.onlinesbi.com/"
                  path="./assets/images/sponsors/sbi.png"
                  title="State Bank of India"
                />
              </Fade>
              <a
                href="https://www.onlinesbi.com/"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "We are privileged to State Bank of India as the sponsors of
                  @tedxbitd . We are greatful such renowned sponsor partner with
                  us. "
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Merchandise </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="https://www.indiamart.com/utkarshenterprises-bhilai/"
                  path="./assets/images/sponsors/utkarsh.png"
                  title="Utkarsh Enterprises"
                />
              </Fade>
              <a
                href="https://www.indiamart.com/utkarshenterprises-bhilai/"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "Utkarsh Enterprises our Merchandise Partner are providing
                  sponsors to TEDXBITD. Let's begin the Event with the support
                  of Utkarsh Enterprises for the Utkarsh (Unnati) of the
                  @tedxbitd ."
                </p>
              </a>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Travel </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="https://www.instagram.com/pandey_cab/"
                  path="./assets/images/sponsors/pandey.png"
                  title="Pandey Cabs"
                />
              </Fade>
              <a
                href="https://www.instagram.com/pandey_cab/"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "We introduce you to our Travel Partners who filled @tedxbitd
                  2023 with the fuel of energy and excitement."
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Food</strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="https://www.instagram.com/karavas_420/"
                  path="./assets/images/sponsors/karavas.png"
                  title="Karavas"
                />
              </Fade>
              <a
                href="https://www.instagram.com/karavas_420/"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "We are grateful to karavas, our food partner as the sponsor
                  of @tedxbitd . We are glad having such renowned sponsor
                  Partner with us @karavas_420"
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Media </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="https://www.instagram.com/dfordurg/"
                  path="./assets/images/sponsors/dfd.png"
                  title="DforDurg"
                />
              </Fade>
              <a
                href="https://www.instagram.com/dfordurg/"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "Enjoy the moments and scenes of @tedxbitd with the help of
                  our media partner @dfordurg "
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Gifting </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="https://www.instagram.com/the_perfect_memories/"
                  path="./assets/images/sponsors/tpm.png"
                  title="The Perfect Memories"
                />
              </Fade>
              <a
                href="https://www.instagram.com/the_perfect_memories/"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "Capture the person capture the moments capture the memories
                  with our gifting partner @the_perfect_memories "
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Decoration </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="https://www.instagram.com/welcomedecorators"
                  path="./assets/images/sponsors/wd.png"
                  title="Welcome Decorators"
                />
              </Fade>
              <a
                href="https://www.instagram.com/welcomedecorators"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "See the beauty of a place @tedxbitd with the help of our
                  decorations partner @welcomedecorators"
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Display </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="https://www.instagram.com/theweddingcorporate"
                  path="./assets/images/sponsors/twc.png"
                  title="TWC"
                />
              </Fade>
              <a
                href="https://www.instagram.com/theweddingcorporate"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "See @tedxbitd with our display partner @twc_event"
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Sound & Lightning </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/dj.png"
                  title="Jhankar Sounds"
                />
              </Fade>
              <a
                href="#"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "Go bright and shine at @tedxbitd with our Sounds and lighting
                  partner JHANKAR SOUNDS @nr_event_jhankar_radio_durg"
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Beverage</strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="https://www.zomato.com/durg-bhilai/juce-wala-2-risali/order"
                  path="./assets/images/sponsors/jw.png"
                  title="Juce Wala"
                />
              </Fade>
              <a
                href="https://www.zomato.com/durg-bhilai/juce-wala-2-risali/order"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "Be cool ; be calm enjoy the sham at @tedxbitd with our
                  beverage partner JUCIEWALA "
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Trading </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/suraj.png"
                  title="Suraj Capital"
                />
              </Fade>
              <a
                href="#"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "Go high on knowledge and wealth to capture your goals at
                  @tedxbitd"
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Snacks </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jcc.png"
                  title="Jain Chaat"
                />
              </Fade>
              <a
                href="#"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "Jain chat center Enjoy the spicy chaat of the jain chaat
                  center, our snacks partner Watching @tedxbitd"
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Snacks </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="https://www.swiggy.com/restaurants/bistro-the-road-side-cafe-gurudwara-road-nehru-nagar-bhilai-647746"
                  path="./assets/images/sponsors/bistro.png"
                  title="Bistro: The Roadside Cafe"
                />
              </Fade>
              <a
                href="https://www.swiggy.com/restaurants/bistro-the-road-side-cafe-gurudwara-road-nehru-nagar-bhilai-647746"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "Exciting News! "BISTRO the Roadside Cafe" joins hands with
                  TEDxBITD as the official Snacks Partner. Fuel your ideas with
                  our delectable treats. Visit us during the event! 🥪
                  #BISTROxTEDxBITD"
                </p>
              </a>
            </div>
          </Fade>
        </div>
        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Snacks </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/softy.png"
                  title="Oo Teri Softy"
                />
              </Fade>
              <a
                href="/"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "O Teri Softy🍦🍦 Introducing to you our snacks partner oo
                  teri softy. Enjoy the creamy softies watching @tedxbitd"
                </p>
              </a>
            </div>
          </Fade>
        </div>

        <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>PR </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList hoverEffect">
              <Fade up>
                <Image
                  link="https://www.instagram.com/feevin.in/"
                  path="./assets/images/sponsors/feevin.png"
                  title="Feevin Media"
                />
              </Fade>
              <a
                href="https://www.instagram.com/feevin.in/"
                style={{ textDecoration: "none" }}
                className="hover"
                target="_blank"
              >
                <p style={{ color: "white" }}>
                  "Feevin Media for all your Event Management Solutions.India's
                  Leading College Social Media Platform"
                </p>
              </a>
            </div>
          </Fade>
        </div>
        {/* <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Sound </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="#"
                  path="./assets/images/sponsors/jhankarr.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div> */}
        {/* <div>
          <Fade up>
            <h2 className="lineTitle">
              <span>
                <strong>Screen </strong> Partner
              </span>
            </h2>
            <div className="sponsorsList">
              <Fade up>
                <Image
                  link="https://www.instagram.com/theweddingcorporate/"
                  path="./assets/images/sponsors/wedding.png"
                  title="Ab classes"
                />
              </Fade>
            </div>
          </Fade>
        </div> */}
      </div>
    </React.Fragment>
  );
};

export default sponsors;
